$(function () {
  var beforePos = 0;

  const scroll_offset = 100;

  function ScrollAnime() {
    var elemTop = 100;
    var scroll = $(window).scrollTop();
    if (scroll == beforePos) {

    } else if (elemTop > scroll || 0 > scroll - beforePos) {
      $('#header').addClass('is-downmove');
      $('#header').removeClass('is-upmove');

    } else {
      $('#header').addClass('is-upmove');
      // setTimeout(() => {
      //   // $('#header').removeClass('is-downmove');
      // }, 100);
    }

    if (scroll < scroll_offset) {
      $('#header').addClass('is-scrolltop');
    } else {
      $('#header').removeClass('is-scrolltop');

    }

    beforePos = scroll;
  }

  function fixedheader() {

    var scroll = $(window).scrollTop();
    if (scroll > scroll_offset) {
      $('.p-single__fixedheader').addClass('is-fixed');
      $('body').addClass('singleheader-fixed');
      $('.p-globalnav__roundbutton').addClass('is-fixed');
    } else {
      $('.p-single__fixedheader').removeClass('is-fixed');
      $('body').removeClass('singleheader-fixed');
      $('.p-globalnav__roundbutton').removeClass('is-fixed');
    }
  }


  $(window).scroll(function () {
    ScrollAnime();

    if ($('.p-single__fixedheader').length > 0) {
      fixedheader()
    }
  });

  $(window).on('load', function () {
    ScrollAnime();

    if ($('.p-single__fixedheader').length > 0) {
      fixedheader()
    }
  });

});
